/**
 * 사이드바 계정 섹션 컴포넌트 (기본 버전)
 * 순환 참조 방지를 위해 UserProfilePreview 등을 외부에서 주입
 */ import React from 'react';
import * as m from '@paraglide/messages';
const AVATAR_BG = 'var(--primary, #3b82f6)';
const renderInitialAvatar = (name, size = 40)=>{
    const initial = name?.charAt(0)?.toUpperCase() ?? '?';
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: AVATAR_BG,
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size >= 40 ? '1rem' : '0.85rem',
            fontWeight: 600
        }
    }, initial);
};
const renderAvatar = (name, src, size = 40)=>{
    if (src) {
        return /*#__PURE__*/ React.createElement("img", {
            src: src,
            alt: name ?? 'avatar',
            style: {
                width: size,
                height: size,
                borderRadius: '50%',
                objectFit: 'cover'
            }
        });
    }
    return renderInitialAvatar(name, size);
};
export const AccountSection = ({ isAuthenticated, userName, userAvatar, onLogout, onLoginClick, isTabletView, isMobileSidebar, isIconOnly = false, userProfileComponent })=>{
    const containerStyle = {
        marginTop: 'auto',
        width: '100%',
        padding: isIconOnly ? '0.5rem 0.5rem 1.25rem' : isMobileSidebar ? '1rem 1.2rem 2rem' : isTabletView ? '1.25rem 1.25rem 1.75rem' : '1.5rem 1.75rem 2.5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: isIconOnly ? 'center' : isMobileSidebar ? 'flex-start' : 'flex-end',
        gap: isIconOnly ? 8 : 12,
        boxSizing: 'border-box'
    };
    const handleLogout = async ()=>{
        if (!onLogout) {
            return;
        }
        try {
            await onLogout();
        } catch (error) {
            console.error('[AccountSection] Logout failed:', error);
        }
    };
    const renderLogoutButton = ()=>{
        if (!onLogout) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("button", {
            onClick: handleLogout,
            style: {
                padding: isIconOnly ? '0.25rem' : '0.35rem 0.65rem',
                fontSize: '0.75rem',
                color: 'var(--danger, #ef4444)',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem'
            },
            title: m.common_logout()
        }, /*#__PURE__*/ React.createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
        }), /*#__PURE__*/ React.createElement("polyline", {
            points: "16 17 21 12 16 7"
        }), /*#__PURE__*/ React.createElement("line", {
            x1: "21",
            y1: "12",
            x2: "9",
            y2: "12"
        })), !isIconOnly && m.common_logout());
    };
    const renderLoginButton = ()=>{
        if (!onLoginClick) {
            return null;
        }
        if (isIconOnly) {
            return /*#__PURE__*/ React.createElement("button", {
                onClick: onLoginClick,
                style: {
                    width: 44,
                    height: 44,
                    borderRadius: '999px',
                    border: '1px solid var(--primary, #3b82f6)',
                    backgroundColor: 'transparent',
                    color: 'var(--primary, #3b82f6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                },
                title: m.common_login()
            }, /*#__PURE__*/ React.createElement("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2"
            }, /*#__PURE__*/ React.createElement("path", {
                d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
            }), /*#__PURE__*/ React.createElement("polyline", {
                points: "10 17 15 12 10 7"
            }), /*#__PURE__*/ React.createElement("line", {
                x1: "15",
                y1: "12",
                x2: "3",
                y2: "12"
            })));
        }
        return /*#__PURE__*/ React.createElement("button", {
            onClick: onLoginClick,
            style: {
                width: '100%',
                padding: '0.6rem 0.75rem',
                borderRadius: '0.75rem',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: 600,
                color: 'white',
                background: 'linear-gradient(135deg, var(--primary, #3b82f6), var(--primary-dark, #2563eb))',
                boxShadow: '0 14px 24px rgba(37, 99, 235, 0.25)'
            }
        }, m.common_login());
    };
    if (isAuthenticated && userProfileComponent) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                marginTop: 'auto',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                paddingBottom: '1.5rem'
            }
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'visible',
                transform: isIconOnly && !isMobileSidebar ? 'scale(0.85)' : undefined,
                transformOrigin: 'top center'
            }
        }, userProfileComponent));
    }
    if (isAuthenticated && !userProfileComponent) {
        const showCompact = isIconOnly || isTabletView;
        if (showCompact) {
            return /*#__PURE__*/ React.createElement("div", {
                style: containerStyle
            }, renderAvatar(userName, userAvatar, isIconOnly ? 36 : 40), renderLogoutButton());
        }
        return /*#__PURE__*/ React.createElement("div", {
            style: containerStyle
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMobileSidebar ? 'flex-start' : 'flex-end',
                gap: '0.75rem'
            }
        }, isMobileSidebar && renderAvatar(userName, userAvatar), /*#__PURE__*/ React.createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: isMobileSidebar ? 'flex-start' : 'flex-end',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ React.createElement("span", {
            style: {
                fontSize: '0.875rem',
                fontWeight: 600,
                color: 'var(--text-primary, #111827)'
            }
        }, userName), renderLogoutButton()), !isMobileSidebar && renderAvatar(userName, userAvatar)));
    }
    // 비로그인 상태
    if (!isAuthenticated) {
        if (isIconOnly) {
            return /*#__PURE__*/ React.createElement("div", {
                style: containerStyle
            }, renderLoginButton());
        }
        return /*#__PURE__*/ React.createElement("div", {
            style: containerStyle
        }, renderLoginButton(), !isTabletView && /*#__PURE__*/ React.createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: 'var(--text-secondary, #6b7280)',
                textAlign: isMobileSidebar ? 'left' : 'right'
            }
        }));
    }
    return null;
};
export default AccountSection;
